export default __webpack_public_path__ + "static/media/cranium-man.664f6591.png";